import React, { useEffect, useState } from 'react';
interface Question {
  id: number;
  text: string;
  options: {
    text: string;
    points: number;
  }[];
}
interface DiagnosticProps {
  question: Question;
  questionIndex: number;
  totalQuestions: number;
  onAnswer: (points: number) => void;
}
export function Diagnostic({
  question,
  questionIndex,
  totalQuestions,
  onAnswer
}: DiagnosticProps) {
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  useEffect(() => {
    setSelectedOption(null);
  }, [question.id]);
  const handleOptionClick = (points: number, index: number) => {
    if (selectedOption !== null) return;
    setSelectedOption(index);
    setTimeout(() => {
      onAnswer(points);
    }, 350);
  };
  const progressWidth = `${(questionIndex + 1) / totalQuestions * 100}%`;
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  }} data-id="element-19">
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    }} data-id="element-20">
        <p style={{
        fontSize: '0.875rem',
        fontWeight: 500,
        color: '#8A8A85'
      }} data-id="element-21">
          Question {questionIndex + 1} of {totalQuestions}
        </p>
        <div className="progress-track" data-id="element-22">
          <div className="progress-fill" style={{
          width: progressWidth
        }} data-id="element-23" />
        </div>
      </div>

      <h2 style={{
      fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
      fontWeight: 600,
      lineHeight: '1.2'
    }} data-id="element-24">
        {question.text}
      </h2>

      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem'
    }} role="group" aria-label={`Question ${questionIndex + 1} options`} data-id="element-25">
        {question.options.map((option, idx) => <button key={idx} onClick={() => handleOptionClick(option.points, idx)} disabled={selectedOption !== null} className={`option-btn ${selectedOption === idx ? 'selected' : ''}`} aria-label={option.text} data-id="element-26">
            {option.text}
          </button>)}
      </div>
    </div>;
}